import React from "react";
import "../hoja-de-estilos/Task.css"
import { AiOutlineCloseCircle } from "react-icons/ai"

function Task({ id, text, completed, completeTask, deleteTask }){
  return(
    <div className={completed ? "task-cont completed" : "task-cont"}>
      <div 
        className="task-text" 
        onClick={()=> completeTask(id)}>
        {text}
      </div>
      <div 
        className="icons-cont"
        onClick={()=> deleteTask(id)}>
        <AiOutlineCloseCircle className="task-icon"/>
      </div>
    </div>
  );
}

export default Task;